import { jsx as _jsx } from "react/jsx-runtime";
import { SPONSORED_NOTICE } from '../field-state/labels.js';
/**
 * The advertising notice of a calendar page (concept 9.3, invariant 2 as changed by D28).
 *
 * One sentence per page instead of a label on each door: every door carries advertising.
 * There is deliberately no `visible` prop; a page that shows doors or their content shows
 * this, and advertising disguised as information is not permissible (concept 10.7). The one
 * case without it is named, not switched: a customer's calendar, whose doors are all the
 * customer's, has no »Partner« to announce (E8).
 */
export function SponsoredNotice({ fieldTerm = 'door', customerCalendar = false, className, }) {
    if (customerCalendar) {
        return null;
    }
    const classNames = ['countdown-sponsored-notice', className].filter(Boolean).join(' ');
    return _jsx("p", { className: classNames, children: SPONSORED_NOTICE[fieldTerm] });
}
//# sourceMappingURL=SponsoredNotice.js.map